import * as _ from 'lodash';
var EventTarget = /** @class */ (function () {
    function EventTarget(target) {
        var _this = this;
        this._handlers = {};
        this._pools = {};
        // ------------------------------------
        // Utils
        // ------------------------------------
        this._emit = function (name) { return function (event) {
            _.forEach(_this._pools, function (pool, poolName) {
                var _a = name, handlers = pool[_a];
                if (!handlers)
                    return;
                if (poolName === 'default') {
                    _.forEach(handlers, function (handler) { return handler(event); });
                    return;
                }
                _.last(handlers)(event);
            });
        }; };
        this._normalize = function (handlers) {
            return _.isArray(handlers) ? handlers : [handlers];
        };
        // ------------------------------------
        // Listeners handling
        // ------------------------------------
        this._listen = function (name, useCapture) {
            if (useCapture === void 0) { useCapture = false; }
            if (_.has(_this._handlers, name))
                return;
            var handler = _this._emit(name);
            _this.target.addEventListener(name, handler, useCapture);
            _this._handlers[name] = handler;
        };
        this._unlisten = function (name, useCapture) {
            if (useCapture === void 0) { useCapture = false; }
            if (_.some(_this._pools, name))
                return;
            var _a = name, handler = _this._handlers[_a];
            _this.target.removeEventListener(name, handler, useCapture);
            delete _this._handlers[name];
        };
        // ------------------------------------
        // Pub/sub
        // ------------------------------------
        this.empty = function () { return _.isEmpty(_this._handlers); };
        this.sub = function (name, handlers, pool, useCapture) {
            if (pool === void 0) { pool = 'default'; }
            if (useCapture === void 0) { useCapture = false; }
            var eventsForName = _.get(_this._pools, pool + "." + name, []);
            var events = _.uniq(eventsForName.concat(_this._normalize(handlers)));
            _this._listen(name, useCapture);
            _.set(_this._pools, pool + "." + name, events);
        };
        this.unsub = function (name, handlers, pool, useCapture) {
            if (pool === void 0) { pool = 'default'; }
            if (useCapture === void 0) { useCapture = false; }
            var eventsForName = _.get(_this._pools, pool + "." + name, []);
            var events = _.without.apply(_, [eventsForName].concat(_this._normalize(handlers)));
            if (events.length > 0) {
                _.set(_this._pools, pool + "." + name, events);
                return;
            }
            _.set(_this._pools, pool + "." + name, undefined);
            _this._unlisten(name, useCapture);
        };
        this.target = target;
    }
    return EventTarget;
}());
export default EventTarget;
